import PropTypes from "prop-types";
import React, { useEffect } from "react";

import { useFlocknoteAppState } from "Flocknote/state";

import PledgeList from "./PledgeList";
import { useUserPledgesList } from "./UserPledgesListContext";
import { useFetchUserPledges } from "./useFetchUserPledges";

UserPledgesList.propTypes = {
  userID: PropTypes.number,
  onPledgeEnd: PropTypes.func,
  showSectionTitle: PropTypes.bool,
  wrapperStyles: PropTypes.object,
};

export default function UserPledgesList({
  userID,
  onPledgeEnd,
  showSectionTitle,
  wrapperStyles,
}) {
  const [appState] = useFlocknoteAppState();
  const fetchUserPledges = useFetchUserPledges();

  const {
    state: { pledges },
  } = useUserPledgesList();

  // TODO: handle triggering a refresh
  const givingDataRefreshTrigger =
    appState.userProfile.givingDataRefreshTrigger;

  useEffect(() => {
    // refetches pledges - givingDataRefreshTrigger updates after an admin creates a pledge for someone from their profile
    // see Giving/Pledging/PledgePanels/SubmitPanel/SubmitPanel.js
    if (givingDataRefreshTrigger > 0) {
      fetchUserPledges(userID);
    }
  }, [givingDataRefreshTrigger, fetchUserPledges, userID]);

  if (!pledges.length) return null;

  return (
    <div style={wrapperStyles}>
      <PledgeList
        key="list"
        showSectionTitle={showSectionTitle}
        userID={userID}
        onPledgeEnd={onPledgeEnd}
      />
    </div>
  );
}